module.exports = __webpack_public_path__ + "img/repair.b0ceeea6.png";